module.exports = __webpack_public_path__ + "static/media/amiok.99f87b12.png";